import { polyLine2IsClosed, polyLine2IsLegal, polyLine2IsSelfIntersecting, SelfIntersectingReason } from "./polyLine2";
import type { PolyLine2 } from "./polyLine2Types";

declare const ClosedPolyLine2Symbol: unique symbol;
export type ClosedPolyLine2 = PolyLine2 & { readonly [ClosedPolyLine2Symbol]: typeof ClosedPolyLine2Symbol };

/**
 * Validates that a PolyLine2 is closed and returns it as a ClosedPolyLine2.
 * Checks for closure, legality (minimum point count), and self-intersections.
 * A closed polyline must have at least 3 distinct points to form a valid polygon.
 * @throws Error if the polyline is not closed, is illegal, or is self-intersecting
 */
export function closedPolyLine2New(pl: PolyLine2): ClosedPolyLine2 {
  const errs: string[] = [];
  if (!polyLine2IsLegal(pl, true, errs)) {
    throw new Error(errs.join("; "));
  }
  if (!polyLine2IsClosed(pl)) {
    throw new Error("PolyLine2 is not closed: first and last points are not coincident");
  }
  const selfIntersectReason = polyLine2IsSelfIntersecting(pl, true);
  if (selfIntersectReason !== false) {
    if (selfIntersectReason === SelfIntersectingReason.LENGTH_ZERO_EDGE) {
      throw new Error("PolyLine2 is degenerate: contains zero-length edge");
    }
    throw new Error(`PolyLine2 is self-intersecting: ${selfIntersectReason}`);
  }
  return pl as ClosedPolyLine2;
}
